import NavbarCompany from "@/components/NavBar/NavbarCompany";
import NavbarInfluencer from "@/components/NavBar/NavbarInfluencer";
import NavbarLoggedOut from "@/components/NavBar/NavbarLoggedOut";
import {useIsAgency, useIsCompany, useIsInfuencer, useIsLoggedIn, useIsSubbrand} from "@/hooks/useUserHooks";
import RefluencedLogoIconSrc from "@/images/Refluenced_Logo_Gradient_Pos.svg";
import {type FC} from "react";
import {Link} from "react-router";

const NavBar: FC<{shouldOnlyShowLogo?: boolean}> = ({shouldOnlyShowLogo = false}) => {
  const isLoggedIn = useIsLoggedIn();
  const isCompany = useIsCompany();
  const isSubbrand = useIsSubbrand();
  const isAgency = useIsAgency();
  const isInfluencer = useIsInfuencer();

  if (shouldOnlyShowLogo) {
    return (
      <nav
        role="navigation"
        className="sticky top-0 z-999 flex h-20 shrink-0 items-center justify-center bg-white px-8 shadow-md">
        <a href="/">
          <img src={RefluencedLogoIconSrc} className="h-12" />
        </a>
      </nav>
    );
  }

  return (
    <nav
      role="navigation"
      className="sticky top-0 z-999 flex h-20 shrink-0 items-center justify-between bg-white px-8 shadow-md">
      <Link to="/">
        <img src={RefluencedLogoIconSrc} className="h-12" />
      </Link>
      {(isCompany || isSubbrand || isAgency) && <NavbarCompany />}
      {isInfluencer && !isCompany && <NavbarInfluencer />}
      {!isLoggedIn && <NavbarLoggedOut />}
    </nav>
  );
};

export default NavBar;
